import ReactMarkdown from "react-markdown";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";
import rehypeRaw from "rehype-raw";
import { fileUrl } from "@/lib/api";

// Renders science flashcard content: markdown + KaTeX math + limited HTML (sub/sup/tables).
// Light copy-protection friction applied via .ss-protected (not real security).
export function ScienceContent({ text, images = [], className = "", protect = true }) {
  return (
    <div
      className={`ss-content ${protect ? "ss-protected" : ""} ${className}`}
      onContextMenu={protect ? (e) => e.preventDefault() : undefined}
      data-testid="science-content"
    >
      {text ? (
        <ReactMarkdown
          remarkPlugins={[remarkMath]}
          rehypePlugins={[rehypeRaw, rehypeKatex]}
        >
          {text}
        </ReactMarkdown>
      ) : null}
      {images.map((src) => (
        <img key={src} src={fileUrl(src)} alt="Flashcard diagram" draggable={false} />
      ))}
    </div>
  );
}
